define((require) => {
    "use strict";

    const Backbone                      = require("backbone");
    const EditorEvents                  = require("shared/services/EditorEvents");
    const ExperienceURLProvider         = require("ui/experience/ExperienceURLProvider");
    const Marionette                    = require("marionette");
    const SceneThumbnailViewer          = require("ui/viewer/SceneThumbnailViewer");
    const template                      = require("ui/dashboard/TemplateItemView.tpl");
    const TemplateItemViewController    = require("ui/dashboard/TemplateItemViewController");

    const MAX_THUMB_DIMENSION = {width: 215, height: 140};

    /**
     *
     * @class TemplateItemView
     *
     */
    return Marionette.Layout.extend({
        _pending: false,

        /**
         * @type {SceneThumbnailViewer}
         */
        _sceneThumbnailViewer: null,

        className: "content-item experience-item",

        controller: TemplateItemViewController,

        template: template,

        /**
         * Whether the view has been through it's rendering cycle.
         *
         * @type {Boolean}
         */
        rendered: false,

        templateHelpers: function() {
            return {
                // Overwriting the name from the model to avoid js-injection
                name: this.model.get("name"),
                description: this.model.get("description")
            };
        },

        ui: {
            thumbContainer: ".experience-thumb-container",
            preview: "#preview",
            create: "#create"
        },

        events: {
            "click @ui.preview": function(event) {
                event.preventDefault();
                event.stopPropagation();

                const templateId = this.model.get("id");
                const templateExperienceId = this.model.get("content").get("id");

                const eventProperties = {
                    triggerOrigin: "TemplateItemViewPreviewButton",
                    templateExperienceId: templateExperienceId
                };
                EditorEvents.trigger(EditorEvents.constants.OPEN_TEMPLATE_PREVIEW, eventProperties);

                const route = ExperienceURLProvider.provide(templateId, ExperienceURLProvider.ACTION.PREVIEW, 1, undefined, ExperienceURLProvider.TYPES.TEMPLATE);
                Backbone.history.navigate(route, {trigger: true});
                this.options.closeQuickView();
            },

            "click @ui.create": function(event) {
                event.preventDefault();
                event.stopPropagation();

                this.trigger("duplicate", this.model.get("content"), "TemplateItemViewCreateButton");
                this.options.closeQuickView();
            }
        },

        onRender: function() {
            this._renderThumbnail(this.model.get("content"));
            this.rendered = true;
        },

        _renderThumbnail: function(experienceModel) {
            this._sceneThumbnailViewer = new SceneThumbnailViewer({
                model: experienceModel.get("scenes").at(0),
                experience: experienceModel,
                maxDimensions: MAX_THUMB_DIMENSION,
                showStaticScenes: true
            });

            this.ui.thumbContainer.prepend(this._sceneThumbnailViewer.render().$el);
            this.$el.addClass(this.model.get("id"));
        },

        onClose: function() {
            // Make sure to properly close the viewer instance - it was added
            // to the DOM outside of the normal (Marionette) lifecycle - see #onRender
            this._sceneThumbnailViewer.close();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/TemplateItemView.js